import { render, staticRenderFns } from "./TrackersView.vue?vue&type=template&id=1c187643&scoped=true&lang=pug&"
import script from "./TrackersView.vue?vue&type=script&lang=js&"
export * from "./TrackersView.vue?vue&type=script&lang=js&"
import style0 from "./TrackersView.vue?vue&type=style&index=0&id=1c187643&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c187643",
  null
  
)

export default component.exports